import { useCallback } from "react";
import moment from "moment-timezone";
import { useGroups } from "../../../Settings/General/OrganisationLevelGroups/context";
import { getPrimaryActiveResource } from "../../../../utils/helpers/user";
import { renderDurationAsFormat } from "../../../../utils/helpers/date";
import { getResourceGroupValues } from "../helpers/data/getGroupedResources";
import { getResourceUserId } from "../helpers/data/groupedResourceId";

export const useFormatDragAndDropData = ({ resource }: any) => {
    const { allocatedGroups } = useGroups();

    return useCallback((item: any, newStartDate: any, newEndDate: any) => {
        const userTimezone = moment.tz.guess(true);
        const startMoment = moment(newStartDate).set({ millisecond: 0, second: 0 });
        let endMoment = moment(newEndDate).set({ millisecond: 0, second: 0 });
        if (endMoment.isBefore(startMoment)) {
            endMoment.add(1, "day");
        }
        const start = startMoment.unix();
        const end = endMoment.unix();
        const duration = end - start;

        // A grouped row keeps the job/location/level it is grouped by
        const groupValues = getResourceGroupValues(resource);
        const job = groupValues.job || getPrimaryActiveResource(resource?.jobs || []) || item?.sections?.[0]?.job;

        const levels = allocatedGroups?.reduce((total: any, group: any) => {
            const level = group?.level.replace("_", "");
            if (resource && resource[level]) {
                return { ...total, [level]: resource[level]};
            } else if (item && item[level]) {
                return { ...total, [level]: item[level] };
            } else {
                return total;
            }
        }, {});

        let sections = item.sections.map((section: any, index: number) => ({
            ...section,
            job,
            location: getPrimaryActiveResource(resource?.locations || []) || section?.location,
            ...levels,
            ...groupValues,
            start: index === 0 ? startMoment : startMoment.clone().add(section.start, "seconds"),
            end: index === item.sections.length - 1 ? endMoment : startMoment.clone().add(section.end, "seconds")
        })).map((section: any) => ({
            ...section,
            start: moment(section.start).tz(userTimezone, true),
            end: moment(section.end).tz(userTimezone, true),
            duration: renderDurationAsFormat(moment(section.end).diff(moment(section.start), "seconds"), "HH:mm")
        })).filter((section: any) => {
            return moment(section.end).isAfter(section.start) &&
                moment(section.start).isBefore(endMoment) &&
                moment(section.end).isAfter(startMoment);
        });

        // const timezone = sections?.[0]?.location?.timezoneValue || company?.timezone?.value;

        return {
            oldResourceId: getResourceUserId(item?.resourceId),
            // startDate: timezone
            //     ? moment(newStartDate).tz(timezone, true).toISOString(true)
            //     : moment(newStartDate).toISOString(true),
            // endDate: timezone
            //     ? moment(newEndDate).tz(timezone, true).toISOString(true)
            //     : moment(newEndDate).toISOString(true),
            startDate: moment(startMoment).toISOString(true),
            endDate: moment(endMoment).toISOString(true),
            date: moment(newStartDate).format("YYYY-MM-DD"),
            duration,
            endTimestamp: end,
            id: item.id,
            isSimple: item?.isSimple,
            rate: job?.hourlyRate || 0,
            total: ((duration / 3600) * (job?.hourlyRate || 0)),
            sections,
            status: item.status,
            timestamp: start,
            user: getResourceUserId(resource?.id || item?.user),
            oldDate: item.oldDate
        };
    }, [resource, allocatedGroups]);
}
